import { ArrowSquareOut, PlayCircle } from "@phosphor-icons/react";

import { Button } from "@/components/ui/button";
import { getStoryThumbnailUrl } from "@/utils/storyMedia";
import { getStoryDisplayTitle } from "@/utils/storySections";
import { getYouTubeEmbedUrl, isVerticalStory } from "@/utils/videoEmbed";

export const VerticalVideoFrame = ({ story, compact = false }) => {
  const embedUrl = getYouTubeEmbedUrl(story?.video_url || story?.permalink);
  const displayTitle = getStoryDisplayTitle(story);
  const isVertical = isVerticalStory(story);
  const buttonLabel = compact ? "Open Video" : "Open on YouTube";
  const frameMaxWidth = compact ? "max-w-[18rem]" : "max-w-[22rem]";
  const shellAspectRatio = isVertical ? "aspect-[9/16]" : "aspect-[16/10]";
  const frameTestId = story?.slug || "fallback";
  const thumbnailUrl = getStoryThumbnailUrl(story);

  const renderMedia = () => {
    if (embedUrl) {
      return (
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="h-full w-full"
          data-testid={`vertical-video-embed-${frameTestId}`}
          referrerPolicy="strict-origin-when-cross-origin"
          src={embedUrl}
          title={displayTitle || "Content Watch video"}
        />
      );
    }

    return <img alt={displayTitle || "Content Watch video"} className="h-full w-full object-cover" src={thumbnailUrl} />;
  };

  return (
    <div className={`border border-[rgba(255,255,255,0.14)] bg-slate-950/70 p-3 backdrop-blur-sm ${frameMaxWidth}`} data-testid={`vertical-video-frame-${frameTestId}`}>
      <div className={`relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-slate-950 ${shellAspectRatio}`} data-testid={`vertical-video-shell-${frameTestId}`}>
        {renderMedia()}
        <div className="absolute left-3 top-3 inline-flex items-center gap-2 bg-[#D21404] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.18em] text-white" data-testid={`vertical-video-badge-${frameTestId}`}>
          <PlayCircle size={14} weight="fill" />
          {isVertical ? "Vertical live" : "Live video"}
        </div>
      </div>
      <div className="mt-3 space-y-2 text-white">
        <p className="eyebrow text-red-300" data-testid={`vertical-video-source-${frameTestId}`}>{story?.source_title || "Content Watch"}</p>
        <p className="font-['Outfit'] text-lg font-bold tracking-tight" data-testid={`vertical-video-title-${frameTestId}`}>{displayTitle || "Latest Content Watch video"}</p>
        {story?.permalink ? (
          <Button asChild className="w-full rounded-none bg-white px-3 text-[11px] font-bold uppercase tracking-[0.18em] text-slate-950 hover:bg-slate-100" data-testid={`vertical-video-open-button-${story.slug}`}>
            <a href={story.permalink} rel="noreferrer" target="_blank">
              {buttonLabel}
              <ArrowSquareOut size={16} weight="bold" />
            </a>
          </Button>
        ) : null}
      </div>
    </div>
  );
};